<template>
  <div class="content" v-bind:class="{ 'theme-red': roleId === 5 || roleId === 7 }">
    <div
      class="mobile-overlay"
      v-bind:class="[{ 'display-Block': displaySide, 'display-none': !displaySide }]"
      @click="displaySide = false"
    ></div>
    <header-nav
      v-if="roleId"
      :accountsList="accountsList"
      :roleId="roleId"
      :userCompany="userCompany"
      @mobilesidebar="mobilesidebar"
      :displaySide="displaySide"
      :account_id="account_id"
      :editDashboard="editDashboard"
      @accountSettingsPopUpClose="accountSettingsPopUpClose"
      :account_type_id="account_type_id"
    ></header-nav>
    <header-menu
      v-if="roleId"
      :roleId="roleId"
      @mobilesidebar="mobilesidebar"
      :accountId="account_id"
      :displaySide="displaySide"
      :isDashboardCustomizable="isDashboardCustomizable"
      @openDashboardEdit="openDashboardEdit"
      :account_type_id="account_type_id"
    ></header-menu>
    <template v-if="online"
      ><router-view
        v-if="roleId"
        :roleId="roleId"
        :account_id="account_id"
        :userId="userId"
        :account_type_id="account_type_id"
      ></router-view
    ></template>
    <div class="content-wrappper" v-else>
      <network-connection></network-connection>
    </div>
    <progress-bar
      :showHelp="showHelp"
      :progressTitleStatus="progressTitleStatus"
      :progressStatus="progressStatus"
      :percentage="percentage"
      @updateProgressStatus="updateProgressStatus"
      :progressTitle="progressTitle"
    ></progress-bar>
    <timeout-warning></timeout-warning>
    <team-member-restriction></team-member-restriction>
    <service-not-added-popup />
  </div>
</template>
<script>
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import HeaderNav from './HeaderNav.vue';
import HeaderMenu from './HeaderMenu.vue';
import welcomePopup from '../VirtualTour/WelcomePopup.vue';
import AccountSettingsPopup from '../VirtualTour/AccountSettingsPopup.vue';
import EventBus from '../../utils/event-bus';
import ProgressBar from '../UIComponents/ProgressBar.vue';
import NetworkConnection from '../Common/NetworkConnection.vue';
import TimeoutWarning from './TimeoutWarning.vue';
import TeamMemberRestriction from './TeamMemberRestriction.vue';
import ServiceNotAddedPopup from './serviceNotAddedPopup.vue';
import { getUserData, getProfileData } from '../../apis/profile';
import { getAllCountries } from '../../apis/countriesList';
import { getRefreshToken, getAccountsList } from '../../apis/login';
import { getPlans } from '../../apis/plans';
import { getActiveServices } from '../../apis/marketPlace';
import { getAddonDetails, getUtilization, postPlan } from '../../apis/psm';
import { getTeamMemberRestriction } from '../../apis/team';
import { isDashboardCustomizable } from '../../apis/dashboardCustomization';
import postMarketoFormData from '../../apis/marketo';
import { isDefaultAvailable } from '../../apis/regulatoryIntelligence';

export default {
  data() {
    return {
      editDashboard: false,
      accountsList: [],
      userCompany: '',
      roleId: '',
      userId: '',
      progressStatus: false,
      percentage: 0,
      errors: [],
      progressTitle: '',
      progressTitleStatus: '',
      showHelp: false,
      account_id: '',
      countryList: [],
      displaySide: false,
      refreshTokenInterval: '',
      rep_client_services: [1, 2, 4, 6],
      timeoutID: null,
      account_type_id: null,
      resizeEventHandler: '',
      tourStatus: false,
      isDashboardCustomizable: false,
      options: [
        {
          name: '250 & 2GB',
          desc: 'Included',
          value: 250,
          storage: '2097152',
          price: '0'
        },
        {
          name: '1000 & 4GB',
          desc: '+$200',
          value: 1000,
          storage: '4194304',
          price: '200'
        },
        {
          name: '2000 & 6GB',
          desc: '+$300',
          value: 2000,
          storage: '6291456',
          price: '300'
        },
        {
          name: '3000 & 8GB',
          desc: '+$400',
          value: 3000,
          storage: '8388608',
          price: '400'
        },
        {
          name: '4000 & 10GB',
          desc: '+$500',
          value: 4000,
          storage: '10485760',
          price: '500'
        },
        {
          name: '5000 & 12GB',
          desc: '+$600',
          value: 5000,
          storage: '12582912',
          price: '600'
        }
      ],
      online: true
    };
  },
  components: {
    TimeoutWarning,
    HeaderNav,
    HeaderMenu,
    ProgressBar,
    TeamMemberRestriction,
    welcomePopup,
    AccountSettingsPopup,
    NetworkConnection,
    ServiceNotAddedPopup
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    openDashboardEdit() {
      this.editDashboard = true;
    },
    accountSettingsPopUpClose() {
      this.editDashboard = false;
    },
    async checkDashboardCustomizable() {
      this.isDashboardCustomizable = await isDashboardCustomizable(
        JSON.parse(localStorage.getItem('userData')).account_id,
        JSON.parse(localStorage.getItem('userData')).role_id
      );
    },
    async getAccountsList() {
      const response = await getAccountsList();
      if (response.status_code === 200) {
        this.accountsList = response.data.accounts.filter(
          (accounts) => accounts.account_id !== this.account_id
        );
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to fetch accounts',
          group: 'custom-notification',
          duration: -1,
          closeOnClick: true
        });
      }
    },
    mobilesidebar() {
      this.displaySide = !this.displaySide;
    },
    updateProgressStatus() {
      this.progressStatus = false;
    },
    async getUserData() {
      const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData'))
        : await getUserData();
      if (userData) {
        this.roleId = userData.role_id;
        this.userId = userData.id;
        this.account_id = userData.account_id;
        this.account_type_id = userData.account_type_id;
        this.userCompany = userData.company;
        if (
          this.roleId === 4 &&
          !this.$route.path.includes('/report') &&
          !this.$route.path.includes('/market-place/service/1') &&
          !this.$route.path.includes('/layout/PermissionAccess')
        ) {
          window.location.href = '/layout/report/summary';
        }
        const utmCodes = JSON.parse(localStorage.getItem('utm_codes'));
        const marketoForm = {
          form_id: 2800,
          input: [
            {
              lead_form_fields: {
                first_name: userData.first_name,
                last_name: userData.last_name,
                email: userData.email,
                company: userData.company,
                country: userData.country,
                last_interest: 'Market Access',
                page_url: window.location.href,
                page_url_referral: document.referrer ? document.referrer : window.location.href,
                form_control: 'Log in'
              },
              visitor_data: {
                page_url: window.location.href
              }
            }
          ]
        };
        if (utmCodes) {
          marketoForm.input[0].lead_form_fields.gAKeyword = utmCodes.keyword;
          marketoForm.input[0].lead_form_fields.utmcampaign = utmCodes.utm_campaign;
          marketoForm.input[0].lead_form_fields.utmcontent = utmCodes.utm_content;
          marketoForm.input[0].lead_form_fields.utmmedium = utmCodes.utm_medium;
          marketoForm.input[0].lead_form_fields.utmmktoadid = utmCodes.utm_mktoadid;
          marketoForm.input[0].lead_form_fields.utmmktocampaign = utmCodes.utm_mktocampaign;
          marketoForm.input[0].lead_form_fields.utmsource = utmCodes.utm_source;
          marketoForm.input[0].lead_form_fields.utmterm = utmCodes.utm_term;
        }
        postMarketoFormData(marketoForm);
      }
    },
    async getProfileData() {
      const userDataStorage = await getProfileData();
      if (userDataStorage) {
        localStorage.setItem('profileData', JSON.stringify(userDataStorage));
      }
      EventBus.$emit('updateProfile');
    },
    addSocketEvents(userId) {
      socket.on(`alertSaveMultiRegistrationDetails_${userId}`, (data) => {
        if (!this.progressStatus) {
          this.progressStatus = true;
          this.progressTitle = 'registrations';
          this.progressTitleStatus = 'import';
          this.showHelp = false;
        }
        this.percentage = data;
      });
    },
    removeSocketEvents(userId) {
      socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${userId}`);
    },
    async getAndAddServices() {
      if (this.account_type_id === 2) {
        await this.validateNAddServices();
      }
      if (this.account_type_id === 4) {
        await this.validateAddRegIntel();
      }
    },
    async validateAddRegIntel() {
      const [activeServices, plans] = await Promise.all([
        getActiveServices(localStorage.getItem('accountId')),
        getPlans()
      ]);
      const servicesPlansIds = activeServices.services || [];

      const validUntil = moment.utc().add(1, 'years').subtract(1, 'days');
      if (!servicesPlansIds.some((plan) => plan === 2)) {
        const addon = [];
        const planDetails = plans.find((plan) => plan.id === 2);
        if (planDetails.id === 2) {
          addon.push({
            account: false,
            active: true,
            id: 11,
            price: 499,
            valid_from: moment.utc(),
            valid_until: validUntil,
            volume: 1,
            regulatory_intelligence: {
              all: true,
              country_id: []
            }
          });
          const formData = {
            account_id: this.account_id,
            active: true,
            add_on: addon,
            operation: 24,
            payment_mode: 4,
            plan_id: planDetails.id,
            plan_price: 0,
            service_type: 'premium',
            total_amount: 0,
            valid_from: moment.utc(),
            valid_until: validUntil
          };
          await postPlan(formData);
        }
      }
    },
    async validateNAddServices() {
      const [activeServices, plans] = await Promise.all([
        getActiveServices(localStorage.getItem('accountId')),
        getPlans()
      ]);
      let servicesPlansIds = activeServices.services || [];
      const isDefaultMarket = await isDefaultAvailable(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      if (isDefaultMarket) {
        servicesPlansIds = servicesPlansIds.filter((s) => s !== 2);
      }
      const validUntil = moment.utc().add(1, 'years').subtract(1, 'days');
      const addonDetails = await getAddonDetails(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      const index = addonDetails.findIndex((addon) => addon.units === 'RECORDS');
      if (index >= 0) {
        const records = addonDetails[index];
        this.recordCurrentUtilization = records.current_utilization;
      } else {
        const currentUtilization = await getUtilization(
          3,
          JSON.parse(localStorage.getItem('userData')).account_id
        );
        this.recordCurrentUtilization = currentUtilization;
      }
      let [defaultRecords] = this.options;
      if (this.recordCurrentUtilization <= 250) {
        [defaultRecords] = this.options;
      } else if (this.recordCurrentUtilization > 250 && this.recordCurrentUtilization <= 1000) {
        [, defaultRecords] = this.options;
      } else if (this.recordCurrentUtilization > 1000 && this.recordCurrentUtilization <= 2000) {
        [, , defaultRecords] = this.options;
      } else if (this.recordCurrentUtilization > 2000 && this.recordCurrentUtilization <= 3000) {
        [, , , defaultRecords] = this.options;
      } else if (this.recordCurrentUtilization > 3000 && this.recordCurrentUtilization <= 4000) {
        [, , , , defaultRecords] = this.options;
      } else if (this.recordCurrentUtilization > 4000 && this.recordCurrentUtilization <= 5000) {
        [, , , , , defaultRecords] = this.options;
      } else if (this.recordCurrentUtilization > 5000) {
        defaultRecords = this.recordCurrentUtilization;
      }
      this.rep_client_services.forEach(async (value) => {
        if (!servicesPlansIds.some((plan) => plan === value)) {
          const addon = [];
          const planDetails = plans.find((plan) => plan.id === value);
          if (planDetails.id === 1) {
            addon.push({
              account: false,
              active: true,
              id: 2,
              price: 0,
              valid_from: moment.utc(),
              valid_until: validUntil,
              volume: defaultRecords.storage
            });
            addon.push({
              account: false,
              active: true,
              id: 3,
              price: 0,
              valid_from: moment.utc(),
              valid_until: validUntil,
              volume: defaultRecords.value
            });
          }
          if (planDetails.id === 2) {
            addon.push({
              account: false,
              active: true,
              id: 11,
              price: 499,
              valid_from: moment.utc(),
              valid_until: validUntil,
              volume: 1,
              regulatory_intelligence: {
                all: true,
                country_id: []
              }
            });
          }
          const formData = {
            account_id: this.account_id,
            active: true,
            add_on: addon,
            operation: 24,
            payment_mode: 4,
            plan_id: planDetails.id === 6 ? 7 : planDetails.id,
            plan_price: 0,
            service_type: 'premium',
            total_amount: 0,
            valid_from: moment.utc(),
            valid_until: validUntil
          };
          await postPlan(formData);
        }
      });
    },
    idleTimer() {
      window.addEventListener('mousemove', this.resetTimer, false); // catches mouse movements
      window.addEventListener('mousedown', this.resetTimer, false); // catches mouse movements
      window.addEventListener('keypress', this.resetTimer, false); // catches mouse clicks
      window.addEventListener('click', this.resetTimer, false); // catches scrolling
      window.addEventListener('scroll', this.resetTimer, false); // catches keyboard actions
      window.addEventListener('keydown', this.resetTimer, false);
    },
    resetTimer() {
      clearTimeout(this.timeoutID);
      localStorage.setItem('updateIdle', Date.now());
      this.timeoutID = setTimeout(() => {
        $('#warningTimeout').modal({ backdrop: 'static', keyboard: false });
      }, 900000);
    },
    async checkTeamMemberRestriction() {
      if (this.account_type_id !== 1 || this.account_type_id !== 5) {
        const response = await getTeamMemberRestriction({ is_rep: (this.account_type_id === 2 || this.account_type_id === 4) });

        if (response.status_code === 200 && response.restrict_user) {
          $('#teamMemberRestrictionPopup').modal({
            backdrop: 'static',
            keyboard: false
          });
        }
      }
    }
  },
  watch: {
    userId() {
      this.removeSocketEvents(this.userId);
      setTimeout(() => {
        this.addSocketEvents(this.userId);
      }, 0);
    },
    $route() {
      this.online = window.navigator.onLine;
      if (!this.online) sessionStorage.setItem('network-redirect-url', this.$route.path);
      if (this.$route.path !== '/layout/market-place/renew-service')
        sessionStorage.removeItem('renewalServices');
      if (
        this.roleId === 4 &&
        !this.$route.path.includes('/report') &&
        !this.$route.path.includes('/market-place/service/1') &&
        !this.$route.path.includes('/layout/PermissionAccess')
      ) {
        window.location.href = '/layout/report/summary';
      }
    }
  },
  async created() {
    this.resizeEventHandler = _.debounce(() => {
      if (!this.tourStatus) {
        this.displaySide = false;
      }
    }, 500);
    this.countryList = localStorage.getItem('countryList')
      ? JSON.parse(localStorage.getItem('countryList'))
      : await getAllCountries();
    await Promise.all([
      this.getProfileData(),
      this.getUserData(),
      getRefreshToken(),
      this.checkTeamMemberRestriction(),
      this.getAccountsList()
    ]);
    await this.getAndAddServices();
    await this.checkDashboardCustomizable();
    this.idleTimer();
    EventBus.$on('resetTimer', () => {
      this.resetTimer();
    });
    EventBus.$on('alertSaveMultiRegistrationDetails', (data) => {
      if (!this.progressStatus) {
        this.progressStatus = data.progressStatus;
        this.progressTitle = 'registrations';
        this.progressTitleStatus = 'import';
        this.showHelp = false;
      }
      this.percentage = data.percentage;
      if (data.percentage === 100) {
        EventBus.$emit('bulkUpload', { disableAdd: false });
      } else {
        EventBus.$emit('bulkUpload', { disableAdd: true });
      }
    });
    this.refreshTokenInterval = setInterval(getRefreshToken, 1680000);
    EventBus.$on('tourStart', () => {
      this.tourStatus = true;
      $(window).scrollTop(0);
      $('.sidebar-col').scrollTop(0);
      $('body').addClass('hide_scroll');
      this.mobilesidebar();
    });
    EventBus.$on('tourEnd', () => {
      this.tourStatus = false;
      $('body').removeClass('hide_scroll');
    });
    EventBus.$on('closeMobileSideBar', () => {
      this.displaySide = !this.displaySide;
    });
    EventBus.$on('loadnetworkerror', () => {
      this.online = window.navigator.onLine;
      if (!this.online) sessionStorage.setItem('network-redirect-url', this.$route.path);
    });
  },
  mounted() {
    window.addEventListener('resize', this.resizeEventHandler);
    $(window).on('beforeunload', () => {
      localStorage.setItem('removeIdlePopups', true);
    });
  },
  beforeDestroy() {
    clearInterval(this.refreshTokenInterval);
    window.removeEventListener('mousemove', this.resetTimer); // catches mouse movements
    window.removeEventListener('mousedown', this.resetTimer); // catches mouse movements
    window.removeEventListener('keypress', this.resetTimer); // catches mouse clicks
    window.removeEventListener('click', this.resetTimer); // catches scrolling
    window.removeEventListener('scroll', this.resetTimer);
    window.removeEventListener('keydown', this.resetTimer);
    window.removeEventListener('resize', this.resizeEventHandler);
    clearTimeout(this.timeoutID);
    EventBus.$off();
  }
};
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 1301px) {
  .mobile-overlay {
    display: none !important;
  }
}
.display-Block {
  display: block;
}
.display-none {
  display: none;
}
.mobile-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
  cursor: pointer;
}
</style>
